exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_object-pie.js
// module id = NpIQ
// module chunks = 4